// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__2MDfV","clinicsSelect":"TableHeading_clinicsSelect__2uMFx"};